module.exports = __webpack_public_path__ + "static/media/MAM.png.png.0d85e9b9.webp";